module.exports = __webpack_public_path__ + "static/media/partnership.98c85e5b.png";